import { render, staticRenderFns } from "./modify-pwd.vue?vue&type=template&id=4ca0a684&"
import script from "./modify-pwd.vue?vue&type=script&lang=js&"
export * from "./modify-pwd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports